<div id="avatar" class="avatar">
  @if (avatarUri) {
    <img
      id="welcome-avatar"
      class="welcome-avatar profile-avatar-image"
      [src]="avatarUri"
      [title]="title"
      [ngStyle]="overlayStyles"
      alt="Profile avatar" />
  } @else {
    <div id="welcome-avatar" class="welcome-avatar" [ngStyle]="overlayStyles">{{ userInitials }}</div>
  }
</div>
